import { typography13RegularStyle } from '../../components/Text';
import { red } from '../colors';

export default {
  root: {
    textAlign: 'right',
    ...typography13RegularStyle,
    marginTop: 0,
    '&.MuiFormHelperText-root.Mui-error': {
      color: red,
    },
  },
  contained: {
    marginRight: 0,
  },
};
